export async function confirmPaymentIntent({
  stripe,
  elements,
  clientSecret,
  returnUrl,
}) {
  if (!stripe || !elements) {
    throw new Error('Stripe is not ready');
  }
  if (!clientSecret) {
    throw new Error('Payment intent client secret is required');
  }

  const { error: submitError } = await elements.submit();
  if (submitError) {
    throw new Error(submitError.message || 'Payment details could not be submitted');
  }

  const { error, paymentIntent } = await stripe.confirmPayment({
    elements,
    clientSecret,
    confirmParams: {
      return_url: returnUrl,
    },
    redirect: 'if_required',
  });

  if (error) {
    throw new Error(error.message || 'Payment confirmation failed');
  }

  return paymentIntent || null;
}
